<template>
  <div class="hkfc-match__wrapper has-space">
    <div class="hkfc-match__container">
      <div class="hkfc-live-video__wrapper">
        <!-- countdown -->
        <div v-if="status === 'showCountdown'" class="hkfc-countdown__wrapper">
          <div class="hkfc-countdown">
            <div class="hkfc-countdown__card-container">
              <div class="hkfc-countdown__card">
                <div class="hkfc-countdown__number">{{ countdown.days }}</div>
                <div class="hkfc-countdown__day">{{ $t("DAYS") }}</div>
              </div>
              <div>:</div>
            </div>
            <div class="hkfc-countdown__card-container">
              <div class="hkfc-countdown__card">
                <div class="hkfc-countdown__number">{{ countdown.hrs }}</div>
                <div class="hkfc-countdown__day">
                  {{ isMobile ? $t("HRS") : $t("HOURS") }}
                </div>
              </div>
              <div>:</div>
            </div>
            <div class="hkfc-countdown__card-container">
              <div class="hkfc-countdown__card">
                <div class="hkfc-countdown__number">{{ countdown.min }}</div>
                <div class="hkfc-countdown__day">
                  {{ isMobile ? $t("MINS") : $t("MINUTES") }}
                </div>
              </div>
              <div>:</div>
            </div>
            <div class="hkfc-countdown__card-container">
              <div class="hkfc-countdown__card">
                <div class="hkfc-countdown__number">{{ countdown.sec }}</div>
                <div class="hkfc-countdown__day">
                  {{ isMobile ? $t("SECS") : $t("SECONDS") }}
                </div>
              </div>
            </div>
          </div>
          <img
            class="w-100 h-100 img-cover"
            src="../../../static/images/hkfc/countdown-bg.png"
          />
        </div>
        <!-- login -->
        <div
          v-if="status === 'showLogin'"
          class="match-detail__video-live-overlay"
        >
          <div class="match-detail__video-live-overlay__title">
            {{ $t("MATCH_DETAIL_TO_SIGN_IN_VIEW_LIVE_VIDEO") }}
          </div>
          <div class="match-detail__video-live-overlay__button-wrapper">
            <router-link
              :to="{ name: 'signup', query: { callBackUrl: currentPathName } }"
            >
              <button class="btn w-100 mb-1rem bg-white">
                {{ $t("SIGNUP") }}
              </button>
            </router-link>
            <router-link
              :to="{ name: 'signin', query: { callBackUrl: currentPathName } }"
            >
              <button class="btn btn-outline w-100">{{ $t("LOGIN") }}</button>
            </router-link>
          </div>
        </div>
        <!-- banner -->
        <div v-if="status === 'showBanner'" class="w-100 h-100">
          <img
            class="w-100 h-100"
            src="../../../static/images/hkfc/no-live-video-bg.png"
          />
        </div>
        <!-- video -->
        <div v-show="status === 'showVideo'" class="w-100 h-100 relative">
          <img
            class="hkfc-live-icon"
            src="../../../static/images/icons/icon_livevideo.png"
          />
          <iframe
            class="w-100 h-100"
            :src="liveVideo"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="hkfc-date__wrapper">
        <div
          class="hkfc-date__card"
          :class="{ selected: o.selected }"
          v-for="(o, index) in dates"
          :key="index"
          @click="selectDate(o)"
        >
          <div class="hkfc-date__title">{{ $t(o.day) }}</div>
          <div>{{ o.date }}{{ addCNCalendarDay }} {{ $t(o.month) }}</div>
        </div>
      </div>
      <div v-if="!isShowNoData">
        <div class="match-wrapper" v-for="(o, index) in matchList" :key="index">
          <div v-if="isMobile" class="hkfc-match__header">
            <img
              class="mr-05rem"
              src="../../../static/images/icons/icon-hkfc.png"
            />
            <div>
              <p>{{ o.leagueName }}</p>
              <p class="hkfc-match__header-country">{{ o.country }}</p>
            </div>
          </div>
          <div
            v-else
            class="display-flex-align-center home-match__title-wrapper"
          >
            <img
              class="mr-05rem"
              src="../../../static/images/icons/icon-hkfc.png"
            />
            <div class="home-match__title">{{ o.country }}</div>
            <span class="home-match__title" v-if="o.leagueName !== null"
              >|</span
            >
            <div class="home-match__title" v-if="o.leagueName !== null">
              {{ o.leagueName }}
            </div>
            <div
              v-if="o.isFavLeague"
              class="icon-fav small"
              :class="{ 'has-subleague-fav': !!o.subLeagueName }"
            ></div>
            <div class="home-match__title" v-if="!!o.subLeagueName">
              : {{ o.subLeagueName }}
            </div>
          </div>
          <router-link
            :to="{ path: formatMatchUrl(o, level2) }"
            target="_blank"
            class="match-container"
            v-for="(level2, index) in o.matchList"
            :key="index"
          >
            <div
              class="home-match__score-card__wrapper flex-col"
              :class="{ 'live-selected': level2.isLive }"
            >
              <div class="home-match__league-group">
                {{ level2.grouped ? level2.grouped : level2.roundEn }}
              </div>
              <div class="display-flex">
                <div class="home-match__status">
                  <span
                    v-show="type === 'team'"
                    v-html="level2.matchStatus"
                  ></span>
                  <span v-show="type !== 'team'">{{ level2.matchStatus }}</span>
                </div>
                <div class="home-match__1-wrapper">
                  <div
                    class="display-flex home-match__1-container"
                    v-for="(level3, index) in level2.opponents"
                    :key="index"
                  >
                    <div class="display-flex-center font-s">
                      <div class="icon-league home-match__icon-team">
                        <img :src="`${s3ImgUrl}/${level3.logo}`" />
                      </div>
                      <span class="mr-03rem home-match__team-name">{{
                        level3.name === "" ? "TBD" : level3.name
                      }}</span>
                      <span
                        v-if="level3.isFavTeam"
                        class="icon-fav tiny mr-03rem"
                      ></span>
                      <span
                        class="penalty-compact-label"
                        v-if="level3.penaltyWin"
                        >P</span
                      >
                      <!-- <img class="img-contain" v-if="level3.penaltyWin" src="../../static/images/label/label_pen_win.png"/>               -->
                    </div>
                    <div>
                      <div class="match-detail__score-wrapper font-s">
                        <span class="score">{{
                          level3.score === "" ? "-" : level3.score
                        }}</span>
                        <span
                          class="penalty-score score"
                          v-if="level3.penaltyScore != null"
                          >{{ level3.penaltyScore }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="home-match__actions-card__wrapper"></div>
          </router-link>
        </div>
      </div>
      <div v-else class="no-data mb-2rem">{{ $t("NO_MATCHES") }}</div>
    </div>
    <div v-if="!isMobile" class="flex-1">
      <Standing></Standing>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import config from "@/js/config.js";
import Standing from "../hkfc/Standing.vue";
import moment from "moment";
export default {
  components: {
    Standing,
  },
  data() {
    return {
      s3ImgUrl: config.s3ImgUrl,
      cnLocaleList: config.cnLocaleList,
      status: "showCountdown",
      liveVideo: null,
      matchList: [],

      intervalCountdown: null,
      countdown: {
        days: "00",
        hrs: "00",
        min: "00",
        sec: "00",
      },
      dates: [
        // {
        //     day: "FRI",
        //     fullDate: "2023/05/26 00:00:00 GMT+0800",
        //     date: "26",
        //     month: "MAY",
        //     value: "2023-05-26",
        //     selected: false
        // },
        // {
        //     day: "SAT",
        //     fullDate: "2023/05/27 00:00:00 GMT+0800",
        //     date: "27",
        //     value: "2023-05-27",
        //     month: "MAY",
        //     selected: false
        // },
        // {
        //     day: "SUN",
        //     fullDate: "2023/05/28 00:00:00 GMT+0800",
        //     date: "28",
        //     value: "2023-05-28",
        //     month: "MAY",
        //     selected: false
        // }
      ],
      isShowNoData: false,
    };
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "isMobile",
      "currentLocale",
      "currentLanguageObj",
      "currentSportType",
    ]),
    addCNCalendarDay() {
      if (this.cnLocaleList.includes(this.currentLocale)) {
        return "日";
      }
      return;
    },
  },
  watch: {
    isLogin: {
      deep: true,
      handler(current, prev) {
        this.init();
      },
    },
  },
  mounted() {
    this.commonVerifyLogin();
    this.init();
  },
  methods: {
    ...mapActions([
      "getHkfcMatchLiveVideos",
      "getHKFCMatchListAsync2",
      "commonVerifyLogin",

      "getSGFCMatchListAsync2",
    ]),
    async getHkfcMatchLiveVideosData() {
      const result = await this.getHkfcMatchLiveVideos();
      if (result.result.urls.length === 0) {
        this.status = "showBanner";
      } else {
        let newLiveVideo = result.result.urls[0];

        newLiveVideo = newLiveVideo + "&start=1";
        //newLiveVideo = "https://www.youtube.com/embed/AWyoXftuxW0?start=60&autoplay=1";
        if (newLiveVideo !== this.liveVideo) {
          this.liveVideo = newLiveVideo;
        }

        this.status = "showVideo";
      }
    },
    initDate() {
      const currentDate = moment();
      let startDate = moment("2023/05/26 18:00:00 GMT+0800");
      let endDate = moment("2023/05/28 17:48:00 GMT+0800");

      let startD = startDate.date();
      let endD = endDate.date();

      let diff = endD - startD + 1;
      this.dates = [];
      for (let i = 0; i < diff; i++) {
        let first = startD + i;

        const formatedDate = moment(`2023/05/${first} 18:00:00 GMT+0800`);
        let obj = {
          date: formatedDate.date(),
          day: this.$tools.getDay(formatedDate.day()),
          month: this.$tools.getMonth(formatedDate.month()),
          value: formatedDate.format("YYYY-MM-DD"),
        };

        if (obj.date === currentDate.date()) {
          obj.day = "TODAY";
        }
        this.dates.push(obj);
      }
      // let diff = endDate.diff(startDate, 'days')

      // for (let i=0; i<this.dates.length; i++) {
      //     const formatedDate = moment(this.dates[i].fullDate);

      //     this.dates[i].date = formatedDate.date();
      //     this.dates[i].day = this.$tools.getDay(formatedDate.day());
      //     this.dates[i].month = this.$tools.getMonth(formatedDate.month());
      //     this.dates[i].value = formatedDate.format("YYYY-MM-DD");

      //     if (this.dates[i].date === currentDate.date()) {
      //         this.dates[i].day =  "TODAY";
      //     }
      // }

      if (currentDate.date() <= parseInt(this.dates[0].date)) {
        this.selectDate(this.dates[0]);
      } else if (
        currentDate.date() >= parseInt(this.dates[this.dates.length - 1].date)
      ) {
        this.selectDate(this.dates[this.dates.length - 1]);
      } else {
        let gg = this.dates.filter((x) => x.date == currentDate.date())[0];
        this.selectDate(gg);
      }
    },
    selectDate(o) {
      this.dates.forEach((element) => {
        element.selected = false;
      });
      o.selected = !o.selected;

      this.getMatchListData(o);
    },
    async getMatchListData(o) {
      let params = {
        leagueIdList: "",
        matchDate: o.value,
        liveOnly: false,
        timeZone: this.$tools.getCurrentTimeZone(),
      };
      const result = await this.getSGFCMatchListAsync2(params); //getHKFCMatchListAsync2
      if (result.result) {
        this.matchList = result.result.leagueMatchList;
        this.isShowNoData = false;
      } else {
        this.isShowNoData = true;
      }
    },
    favMatchClassObj(o) {
      // const matchEndedStatus = config.matchEndedStatus;
      return {
        disable: this.isLogin
          ? this.isMatchEnded(o) // matchEndedStatus.includes(o.matchStatus)
          : false,
        selected: o.isFavMatch,
      };
    },

    initCountDown() {
      const formatNumber = (n) => n.toString().padStart(2, "0");
      const eventTime = moment("2023/05/26 18:00:00 GMT+0800").format("X");

      let currentTime = moment().format("X");
      let diffTime = eventTime - currentTime;
      let duration = moment.duration(diffTime, "seconds");

      if (duration._milliseconds < 0) {
        this.verifyStatus();
        setInterval(() => {
          this.verifyStatus();
        }, 5000);
      }

      let interval = setInterval(() => {
        let currentTime = moment().format("X");
        let diffTime = eventTime - currentTime;
        let duration = moment.duration(diffTime, "seconds");

        if (duration._milliseconds < 0) {
          clearInterval(interval);
          this.verifyStatus();
        } else {
          this.countdown.days = formatNumber(duration.days());
          this.countdown.hrs = formatNumber(duration.hours());
          this.countdown.min = formatNumber(duration.minutes());
          this.countdown.sec = formatNumber(duration.seconds());
        }
      }, 800);
    },

    verifyStatus() {
      if (this.isLogin) {
        this.getHkfcMatchLiveVideosData();
      } else {
        this.status = "showLogin";
      }
    },

    init() {
      this.currentPathName = window.location.pathname;

      this.initDate();
      this.initCountDown();
    },

    formatMatchUrl(o, level2) {
      const defaultTeam = "TBD";

      let homeName = defaultTeam;
      let awayName = defaultTeam;
      let fullName = "";

      if (level2.opponents[0].name) {
        homeName = level2.opponents[0].name.replace(/(\s|\/)/g, "-");
      }
      if (level2.opponents[1].name) {
        awayName = level2.opponents[1].name.replace(/(\s|\/)/g, "-");
      }

      fullName = `${homeName}-vs-${awayName}`;

      let path = `/${this.currentLocale}/${this.currentSportType}/hkfc/${
        o.countryKey ?? ""
      }/${o.leagueKey ?? ""}/${fullName}/${level2.matchId}`;

      return path;
    },
  },
};
</script>

<style scoped>
.hkfc-match__wrapper {
  display: flex;
  gap: 64px;
}
.hkfc-match__container {
  width: 680px;
}

/* live video */
.hkfc-live-video__wrapper {
  position: relative;
  height: 383px;
  overflow: hidden;
  border-radius: 16px;
  margin-bottom: 44px;
}
.hkfc-countdown__wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}
.hkfc-countdown {
  display: flex;
  width: 100%;
  position: absolute;
  bottom: 8rem;
  justify-content: center;
  align-items: center;
}
.hkfc-countdown__card-container {
  display: flex;
  align-items: center;
  font-size: 22px;
  margin-right: 8px;
}
.hkfc-countdown__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  min-width: 56px;
  height: 56px;
  margin-right: 8px;
}
.hkfc-countdown__number {
  font-family: var(--weight-700);
  font-size: 22px;
}
.hkfc-countdown__day {
  font-family: var(--weight-400);
  font-size: 11px;
}
/* date tabs */
.hkfc-date__card {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  cursor: pointer;
  color: white;
  font-size: 11px;
  margin: 0 2px;
  padding: 7px 0;
}
.hkfc-date__card:hover,
.hkfc-date__card.selected {
  background: var(--bg-selected);
  color: black;
}
.hkfc-date__wrapper {
  display: flex;
  margin-bottom: 52px;
}
.hkfc-date__title {
  font-family: var(--weight-700);
}

.match-detail__video-live-overlay {
  background-color: #34343494;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  box-sizing: border-box;
}
.match-detail__video-live-overlay__title {
  margin-bottom: 2rem;
  text-align: center;
}
.match-detail__video-live-overlay__button-wrapper {
  width: 20rem;
}

/* match card*/
.hkfc-match__header {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: var(--weight-700);
  margin-bottom: 8px;
  letter-spacing: 0.64px;
}
.hkfc-match__header-country {
  font-size: 11px;
  font-family: var(--weight-400);
  color: #93a9b4;
}
.hkfc-live-icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.home-match__title-wrapper {
  font-family: var(--weight-700);
}
.home-match__title-wrapper:hover .home-match__title {
  color: white;
}
.skeleton-match__wrapper {
  width: 100%;
  height: 100%;
  padding: 1rem;
  border-radius: 0.5rem;
  box-sizing: border-box;
}

.skeleton-match__title {
  width: 50%;
  height: 1rem;
  margin-bottom: 0.25rem;
}

.skeleton-match__content {
  width: 100%;
  height: 2rem;
  margin-bottom: 0.5rem;
}

.home-match__win-lose {
  background-color: green;
  border-radius: 50%;
  padding: 0.3rem;
  color: white;
  width: 0.75rem;
  border: 0.1rem solid white;
  height: 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.5rem;
}

.home-match__win-lose.W {
  background-color: #5cd66c;
}

.home-match__win-lose.L {
  background-color: #cf283e;
}

.home-match__win-lose.D {
  background-color: #ed9c5a;
}

.home-match__status {
  margin-right: 0.5rem;
  width: 2.25rem; /*1.6rem   2rem*/
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.563rem;
  color: var(--color-grey-light);
}

.home-match__1-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.home-match__1-container {
  justify-content: space-between;
  /* margin-bottom: 0.2rem; */
}
.home-match__team-name {
  color: var(--color-grey-light);
}
.home-match__date {
  margin-bottom: 0.5rem;

  color: var(--color-text-default-default);

  /* Body Strong */
  font-family: var(--typography-body-font-family);
  font-size: var(--typography-body-size-large);
  font-style: normal;
  font-family: var(--weight-700);
  font-weight: var(--weight-700);
  line-height: 140%; /* 22.4px */
  letter-spacing: 0.64px;
}
.match-wrapper {
  margin-bottom: 1.2rem;
}

.match-container {
  display: flex;
  margin-bottom: 0.5rem;
  position: relative;
}

.match-container:hover .home-match__score-card__wrapper {
  background-color: var(--bg-hover);
}

.match-container:hover .home-match__static-card__wrapper {
  background-color: var(--bg-hover);
}

.match-container:hover
  .home-match__actions-card__wrapper
  .home-match__icon-wrapper {
  background-color: var(--bg-hover);
}

.home-match__static-card__wrapper {
  background-color: #35454d;
  padding: 0.5rem 0.25rem 0.2rem;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 6.25rem;
  align-items: center;
}

.home-match__static-card__brief {
  padding: 0.5rem 1.5rem;
}

.home-match__score-card__wrapper {
  display: flex;
  background-color: var(--color-theme);
  border-radius: 0.5rem;
  width: 100%;
  padding: 0.5rem 0.5rem;
  border-left: 0.4rem solid transparent;
}

.home-match__score-card__wrapper.no-odds-match {
  border-radius: 0.5rem;
}

.home-match__actions-card__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.live-selected {
  border-left: 0.4rem solid var(--color-icon-primary-active);
}

.match-status__live {
  background-color: #cf283e;
  padding: 0.2rem;
  border-radius: 0.3rem;
  font-size: 10.4px;
}

.match-detail {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.match-detail__status {
  width: 1.6rem;
}

.match-detail__status-w-auto {
  width: auto;
}

.match-detail__score-wrapper {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.match-detail__score-wrapper .score {
  min-width: 1.25rem;
  min-height: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.688rem;
  font-family: var(--weight-700);
}

.match-detail__name {
  width: 9rem;
  text-align: right;
  display: flex;
  justify-content: flex-end;
}

.match-middle {
  flex: 0.5;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.match-middle__seperator {
  margin: 0 0.5rem;
  font-family: var(--weight-700);
  font-family: var(--weight-700);
}
.has-subleague-fav {
  margin-right: 0.25rem;
}
.penalty-compact-label {
  border-radius: var(--size-radius-100);
  background: var(--color-background-brand-default);
  padding: 2px 4px;
  font-size: 0.813rem;
  font-family: var(--weight-700);
  color: var(--color-tag-active-text);
  position: absolute;
  top: -0.4rem;
  right: -0.6rem;
}
.penalty-score {
  border-left: 1px solid var(--color-grey-40);
}
.home-match__league-group {
  font-size: 9px;
  color: var(--color-grey-light);
  padding-left: 2.5rem;
  margin-bottom: 5.33px;
}
@media (max-width: 400px) {
  .home-match__team-name {
    /* display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical; */
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 9.5rem;
  }
  .home-match__team-name.with-fav-star,
  .home-match__team-name.with-penalty-score {
    max-width: 8.5rem;
  }
  .home-match__team-name.with-fav-star.with-penalty-score,
  .home-match__team-name.with-penalty-score.with-penalty-win {
    max-width: 7.5rem;
  }
  .home-match__team-name.with-fav-star.with-penalty-score.with-penalty-win {
    max-width: 6.5rem;
  }
}

@media (max-width: 320px) {
  .home-match__team-name {
    max-width: 8rem;
  }
  .home-match__team-name.with-fav-star,
  .home-match__team-name.with-penalty-score {
    max-width: 7rem;
  }
  .home-match__team-name.with-fav-star.with-penalty-score,
  .home-match__team-name.with-penalty-score.with-penalty-win {
    max-width: 6rem;
  }
  .home-match__team-name.with-fav-star.with-penalty-score.with-penalty-win {
    max-width: 5rem;
  }
}
@media (max-width: 768px) {
  /* for test */
  .match-container:hover .home-match__score-card__wrapper {
    background-color: var(--color-theme);
  }
  .hkfc-date__wrapper {
    margin-bottom: 32px;
    padding: 0 1rem;
  }
  .hkfc-live-video__wrapper {
    margin-bottom: 32px;
    height: 45vw;
  }
  .hkfc-countdown__day {
    font-size: 9px;
  }
  .hkfc-countdown__number {
    font-size: 11px;
  }
  .hkfc-countdown__card-container {
    font-size: 11px;
    margin-right: 4px;
  }
  .hkfc-countdown__card {
    min-width: 32px;
    height: 32px;
    margin-right: 4px;
  }
  .hkfc-countdown {
    bottom: 13vw;
  }
}
</style>
